import {mobXContextValue} from "../../../../app/mobx/MobXContext";

export default (menuItemTarget, field, value) => {
	menuItemTarget[field] = value;
	mobXContextValue.configuratorStore.fieldWasUpdated(menuItemTarget.id);
};
